/** BILION PASS — terms of service (Japanese) */
export const termsTitle = "BILION PASSサービス利用規約";

export const termsBody = `
本利用規約（以下「本規約」といいます。）は、Japan DX株式会社（以下「当社」といいます。）が運営するBILION PASS Webサイト（以下「本サイト」といいます。）上で提供される各種サービス（以下「本サービス」といいます。）の利用条件を定めるものです。本サイトの利用者（以下「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。
第１条（本規約の適用範囲） 
1.本規約は、本サービスをご利用になるユーザー全てに適用されます。 
2.本規約と別に当社が本サービスに関して定める諸規定は、それぞれ本規約の一部を構成するものとします。 
3.本規約の規定と前項により当社が別途定める諸規定の内容が異なる場合には、当該諸規定の内容が優先的に適用されるものとします。
第２条（規約の変更）
当社は、ユーザーの了解を得ることなく、本規約に関して条項の追加、変更、削除等をすることがあります。その際の本サービスの利用条件は、変更後の本規約によるものとします。また、変更後の規約は、当社が別途定める場合を除き、本サイト上に表示した時点より、効力を生じるものとし、本規約の変更後、ユーザーが本サービスをご利用された場合には、変更後の本規約に同意したものとみなします。
第３条（利用環境）
本サイトをご利用になるには、インターネット（Web）にアクセスしていただく必要があります。ユーザーには自らの責任と費用で必要な機器・ソフトウェア、通信手段などをご準備いただき、それらを適切に設置、操作いただく必要があります。なお、当社は、ユーザーが行うそれらの準備、方法などには一切関与せず、何らの責任を負いません。
第４条（知的財産権）
1.本サイトおよび本サイトに掲載される著作物等（文章、写真、地図、絵画、図面、図表、映画、音楽、プログラム、データベース等の著作物、二次的著作物および編集著作物を含みますがこれらに限らないものとします。）についての著作権は、当社およびその他の権利者に帰属いたします。これら著作物等については、当社およびその他の権利者に無断で、複製、上演、演奏、上映、公衆送信（送信可能化を含みます）、口述、展示、頒布、譲渡、貸与、翻訳、翻案、改変等を行うことは一切禁止します。
2.本サイト及び本サービスで使用されている商号、商品の名称、サービス名称、ロゴマーク等は当社およびその他の権利者の登録商標または商標です。これらの商標については、当社およびその他の権利者に無断で使用してはならないものとします。
第５条（本サイトへのリンク）
本サイトのユーザーは、以下の各号のいずれかに該当する、もしくはそのおそれのある方法で本サイトのリンクを貼ることは禁止します。 
①営利を目的としたものである場合 
②画像に対する直接リンクの場合（画像表示について） 
③当社に社会的・経済的損失が生じると考えられる場合 
④独自のフレームの中に、本サイトを取り込んだ形でリンクされる場合 
⑤第三者が著作権を保有し、記事へのリンクを禁止している場合 
⑥その他、本サービスの運営に支障を来すおそれがあると当社が判断した場合
第６条（会員登録） 
1.本サイトは会員（会員登録手続きを行い、本サービスを利用するユーザーをいいます。以下同じ。）として登録をせずにご利用いただくことも可能ですが、本サービスのうち一部のサービスをご利用いただく場合には会員登録が必要となります。
2.会員登録に際しては、次の条件をお守りいただく必要があります。 万一下記に違反した場合、または真実かつ正確なデータが提供いただけていないと当社が判断した場合には、当社は当該会員の登録情報を削除し、将来にわたって本サービスのご利用をお断りする場合があります。 
①会員登録のための書式には、会員に登録するユーザーご本人が、ご本人に関する真実かつ正確なデータを入力して、本サイトを通して当社に送信いただきます。 
②登録情報は、常に真実かつ正確な内容であることを維持するために、データ内容に変更が生じた場合には、適宜修正していただきます。また、会員は自己のパスワードを安全に管理してください。 
3.会員登録に際して、登録した登録情報、また、本サービスを利用する上で提供した情報は当社が所有するものとし、当社はかかる情報を、本規約に定めるほか、当社の定めるプライバシーポリシーに従い、本サービスに関連して、もしくは本サービス利用以外の目的のために使用することができるものとします。なお、当社は、かかる情報を第三者に開示する場合には、当該会員の承諾を得ることとします。 
4.当社は、会員から提供された個人情報をもとに、本サービスを通じ、電子メール・WEBでの告知により、個々の会員に応じた情報や、当社および業務提携先の商品・サービスの案内等をすることができるものとします。 
5.当社は会員に対し、当社または業務提携先の事業の参考とするために、アンケートやインタビュー等への協力を求めることができるものとします。
6.会員が次の各号の何れかに該当する場合には、会員資格を喪失し、自動的に退会したものとみなされます。 
①当社が当該会員の入会承認を取消した場合 
②当該会員が本規約の何れかの条項に違反し、当社が当該会員の除名を決定した場合 
③当該会員が所定の手続きに従い当社に退会を申し出た場合 
7.会員への連絡または通知の必要があると当社が判断した場合には、原則として登録されたメールアドレス宛にメールにて連絡または通知を行います。
第７条（会員情報の扱い方） 
会員登録で登録いただく登録情報や、その他に当社が取得した会員に関する情報は、当社の定めるプライバシーポリシーに従い取り扱われます。
第８条（禁止事項） 
本サイトの利用に際し、以下の行為を禁止します。 
①本サイトにより利用しうる情報を改ざん・消去する行為 
②本サイトに接続されている他のコンピュータシステムまたはネットワークへの不正アクセスを試みる行為 
③他のユーザーまたは第三者もしくは当社の著作権、商標権などの知的財産権を侵害する行為、および侵害するおそれのある行為 
④他のユーザーまたは第三者もしくは当社の名誉あるいは信用を毀損する行為、およびそのおそれのある行為 
⑤他のユーザーまたは第三者もしくは当社の財産、プライバシー、肖像権、パブリシティ権を侵害する行為、および侵害するおそれのある行為 
⑥他のユーザーのメールアドレス等を不正に利用したり、譲渡・販売する行為 
⑦AI生成コンテンツを、当社の許可なく商用目的で転載・販売する行為。
⑧クーポンを不正に複製、改ざん、または第三者へ転売する行為。
⑨サーバーまたはネットワークの機能を破壊したり、妨害したりする行為。
⑩営業活動または営利を目的とする行為、およびその準備を目的とする行為 
⑪コンピュータウィルスなど有害なプログラムを使用または提供する行為、およびそのおそれのある行為 
⑫他のユーザーまたは第三者もしくは当社になりすまして、本サービスを利用する行為 
⑬他のユーザーまたは第三者もしくは当社に不利益あるいは損害を与える行為、およびそのおそれのある行為 
⑭公序良俗に反する行為、およびそのおそれのある行為 
⑮犯罪行為または犯罪に結びつく行為、およびそのおそれのある行為 
⑯その他、法律、法令、または条例に違反する行為、およびそのおそれのある行為 
⑰民族的・人種差別的な行為 
⑱本サイトの運営を妨げるような行為 
⑲前各号に定める行為を助長する行為 
⑳その他、当社が不適切と判断する行為
第９条（損害賠償責任） 
ユーザーが本規約の定める内容に違反して他のユーザーおよび当社に損害を与えた場合には、その損害（弁護士費用を含む）を賠償するものといたします。また、本規約に違反したことが原因で第三者とのトラブルが生じた場合には、ユーザーは自己の責任と費用をもってこれを処理解決し、当社に損害・迷惑を与えないものとします。
第１０条（免責事項） 
1.当社は、本サービスを提供するにあたって、以下の事項につき、一切の保証をいたしません。 
①ユーザーのご要望を完全に満たすこと。 
②掲載されている情報が、速報性・正確性・合法性・有用性・完全性を満たしていること。 
③機能の中断、システムのエラー・バグ・不具合等が発生しないこと。 
④欠点を修正すること。 
⑤コンピュータウイルスその他の有害物がないこと。 
⑥本サービスの利用または利用できなかったことにより、ユーザーが損害を受けること。 
2.本サービスでは、現在、観光や旅行に関する情報や機能を提供しておりますが、これらはサービス向上のため、事前の予告なしに追加・変更・中止・削除等する場合があります。 
3.当社は、以下の場合に事前の予告なく、本サイトの運営を中断または中止する場合があります。 
①情報・機能またはシステムの変更を定期的または緊急に行う場合 
②システムまたは設備の点検を定期的または緊急に行う場合 
③天災、地震、停電などが原因で、本サービスの提供を維持できなくなった場合 
④その他予期せぬ事態により、停止・終了する必要が生じた場合 
4.当社は理由の如何に関わらず、本サービスをご利用になったことで生じたいかなる損害、および本サービスの情報・機能の変更や運用の中断・中止によって生じたいかなる損害についても責任を負うものではありません。 
5.本サイトからまたは本サイトへリンクを貼っている当社以外の第三者のウェブサイト（以下「リンクサイト」といいます）の内容は、各リンクサイトの運営主の責任で管理されるものであり、リンクサイトの利用にあたっては、各リンクサイトの利用条件や著作権の取り扱い等の規定に従ってください。 なお、当社は、リンクサイトの内容について、また、リンクサイトをご利用になったことにより生じたいかなる損害についても責任を負いません。
6.当社は天災地変等の不可抗力または営業上のやむを得ない事由もしくは営業戦略上の判断により、本サービスの全部または一部を終了することがあります。
第1１条（譲渡禁止） 
ユーザーは、本サービスの提供を受ける権利を第三者に譲渡、売買、名義変更、質権の設定その他の担保に供する等の行為を行ってはならないものとします。なお、会員登録は一身専属のものとします。
第１２条（お問い合わせ）
1.本サービスに関するお問い合わせは、当社所定の方法によるものとします。
2.ユーザーからのご意見、お問合せ等について ユーザーからのご意見、お問合せに対する当社のメール等による回答につきましては、事前に書面による当社の承諾を得ることなく、複製、公衆送信、転送、転載等を行い、または第三者に開示することを禁止させていただきます。
第１３条（準拠法・裁判管轄）
1.本規約の解釈にあたっては、日本法を準拠法とします。
2.本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
以上
当社が本サービスに関して定める諸規定
AIによる旅行プラン作成サービス
本サービスでは、人工知能（AI）を利用してユーザーの要望に応じた旅行プランを生成します。
AIが生成するプラン（ルート、所要時間、施設情報等）は、必ずしも正確性、最新性、または完全性を保証するものではありません。実際の旅行に際しては、公共交通機関の運行状況や施設の営業時間をユーザー自身で事前に確認するものとします。
その他のサービス
本サービスに適用される条件については、本サイトからの遷移先に掲げる規約をご確認ください。
以上`;
